import styled from 'styled-components';

export const Container = styled.div`
  &.SearchResultsItem{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 32px 0;
  }
  &.MainResultsItem{
    flex: 1;
    margin: 0 23px;
    overflow: hidden;
    & .code-preview{
      max-width: 100%;
      border: 1px solid #ccc;
      border-radius: 4px;
      white-space: pre-wrap;
      font-family: monospace;
      padding: 5px 10px;
      background-color: #fafafa;
    }
  }
  &.RightResultsItem{
    display: flex;
    height: 100%;
    width: 80px;
    justify-content: space-around;
    position: relative;
    align-self: flex-start;
  }
  &.SearchResultIcon{
    margin-top: 10px;
  }
`;

export const StyledImg = styled.img`
  &.ResultsIcon{
    width: 46px;
  }
  &.ResultsClickableImg{
    cursor: pointer;
  }
  &.Bookmark{
    width: 20px;
    height: 20px;
  }
`;

export const TextNormal = styled.span`
  font-weight: 400;
`
export const TextBold = styled.span`
  font-weight: 800;
`

export const StyledH3 = styled.h3`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 180%;
  color: #2C2B48;
  margin-bottom: .3rem;
`;

export const StyledSubject = styled.h3`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 180%;
  color: #2C2B48;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: .25rem;
`

export const SubjectContainer = styled.div`
  
`

export const StyledParagraph = styled.div`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 180%;
  color: #2C2B48;
  font-weight: 500;
  word-break: break-word;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  overflow: hidden;
  & a{
    font-size: 16px!important;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const StyledParagraphMuted = styled.p`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-size: 14px;
  line-height: 180%;
  color: #4f4f4f;
  font-weight: 400;
  max-width: 90%;
  word-break: break-word;
  &.date{
    font-weight: 400;
    font-size: 12px;
  }
`;

export const StyledAttachment = styled.div`
  display: inline-flex;
  height: 100px;
  width: 100px;
  margin-right: 15px;
  align-items: flex-end;
  background: url("../../../images/file-icon.svg");
  & p.text{
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    background: rgba(60, 60, 60, 0.15);
    padding: 0 5px;
  }
`

export const Span = styled.span`
  //font-size: 14px;
  font-weight: 500;
`

export const LinkTitle = styled.a`
  text-decoration: underline;
  color: #0039BB;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  margin-bottom: 13px;
`

export const JiraIssueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #4F4F4F;
  font-size: 14px;
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  & .font-600{
    font-weight: 600;
  }
  &.date{
    font-size: 12px;
    color: #4f4f4f;
  }
`

export const VerticalDivider = styled.span`
  margin: 0 10px;
  border-right: 1px solid #828282;
  height: 14px;
`